import {css} from 'emotion'

export const CatalogStyle = css({
  '.list': {
    justifyContent: 'center',
  },
  '.card': {
    maxWidth: '50%',
    flexBasis: '50%',
    minWidth: 0,
    padding: '0.5rem',
    margin: '1rem 0px',

    '&:first-child, &:last-child': {
      padding: '0.5rem',
    },

    '@media (min-width: 1024px)': {
      maxWidth: 'calc(1/3 * 100%)',
      flexBasis: 'calc(1/3 * 100%)',
    },
    '@media (min-width: 1220px)': {
      maxWidth: '25%',
      flexBasis: '25%',
    }
  },
  '.card-info': {
    minHeight: '150px',
  }, 
  '.catalog-filter': {
    margin:' 0px -20px',

    '@media (min-width: 1024px)': {
      margin: 0, 
    }
  },
  '&.catalog': {
    '.page-inner':{
      paddingTop: 0,
      '@media (min-width: 1024px)': {
        paddingTop: '4rem',
      }
    },
  },
})


// WEBPACK FOOTER //
// ./src/styles/containers/catalog.js